module.exports = __webpack_public_path__ + "static/media/Son in Law 3.731be22f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Son in Law 3.jpg
// module id = 136
// module chunks = 0